
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M13.965 24.102h26.297v-8.095c0-1.062-.424-2.08-1.18-2.83a4.04 4.04 0 0 0-2.846-1.173H18.118L14.092 6H4.026A4.04 4.04 0 0 0 1.18 7.172 4 4 0 0 0 0 10.002v28.02c0 1.06.424 2.079 1.18 2.83a4.04 4.04 0 0 0 2.846 1.172h9.939v-7.882h31.51V28.24h-31.51z"}}),_c('path',{staticClass:"i-folder",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M42.5 19.996v-5.99c0-1.061-.424-2.079-1.18-2.83a4.04 4.04 0 0 0-2.846-1.172H20.356L16.33 4H6.264a4.04 4.04 0 0 0-2.847 1.172 4 4 0 0 0-1.179 2.83v28.02c0 1.06.424 2.079 1.18 2.83a4.04 4.04 0 0 0 2.846 1.172h7.18"}}),_c('path',{staticClass:"i-credit-card",attrs:{"stroke":"#234652","d":"M16.313 44.138V22.97H47.31v21.167z"}})])
          )
        }
      }
    